import { truncate } from "fs";

export const environment = {
  production: false,
  //API标准格式形如：http://xxx.xxx.xxx.xxx/  （注意最后斜杠）
  //#region  seeker基础平台微服务api地址配置区域
  seekerWebAPI: "http://122.112.235.243:9000/sw-basic-cloud/",
  fileWebAPI: "http://122.112.235.243:9000/sw-file-cloud/",
  activitiWebAPI: "http://122.112.235.243:9000/sw-activiti-cloud/",
  scheduleWebApi: "http://122.112.235.243:9000/sw-scheduler-cloud/",
  ruleWebApi: "http://122.112.235.243:9000/sw-rule/",
  webSoketApi: "ws://192.168.10.96:8041/",
  smsWebAPI: "http://192.168.10.96:8021/",
  esWebAPI: "http://122.112.235.243:9000/sw-es/",
  saasWebAPI: "http://122.112.235.243:9000/sw-saas-cloud/",
  staticFileUrl: "http://122.112.235.243:9999/",
  onlineOfficeWebAPI: "http://192.168.10.210:9999/",
  iiifImgUrl: "http://122.112.235.243:8182/iiif/2/",
  uploadDirectory: "swseeker",
  //#endregion 
  // 知识图谱
  qasWebAPI: "http://122.112.235.243:9000/sw-ht-qams-server/",
  kgsWebAPI: "http://122.112.235.243:9000/sw-ht-kgs/",
  kgsBasicApi: "http://122.112.235.243:9000/sw-ht-kgs-basic/",
  // kgsBasicApi: "http://122.112.235.243:9000/sw-kgs4-basic-202512/",
  rmsBasicApi: 'http://122.112.235.243:9000/sw-ht-kgs-rms/',
  mapBasicApi: 'http://122.112.235.243:9000/sw-ht-hgis/',
  sesWebBasicApi: 'http://122.112.235.243:9000/sw-ht-sems-server/',
  sesWebAPI: 'http://122.112.235.243:9000/sw-ht-sems-portal/v2/',
  imgSegmentationApi: 'http://122.112.235.243:9907/',
  ocrApi: 'http://122.112.235.243:9904/',
  //#endregion
  //#region 项目基本属性配置区域
  //#region 逻辑交互配置区
  encryptedPassword: true,
  // encryptedPassword:false,                                     //是否加密密码
  // multiTenancy:true,                                          //是否开启多租户管理模式
  multiTenancy: false,
  kgsSystemId: 'aa3664193b7511eb9cf8000c292fb426kgs',
  systemCode: 'KGS_SWHT',
  isSourceRequired: false,   // 实例来源是否必填
  isInstanceMaterailSearchRequired: false,
  showDictArr: [],  // 默认为空数组，显示所有字典项；有值时显示指定字典项，如：['ZGYD','kgs_dic_v3']
  rootDictId: 'a569efa60e3d41cc95429aae3bb07348',  // 字典根目录id,showDictArr不为空时用到
  isVcode: false,
  isSliderCode: true,
  isRelateDingTalk: true,
  multiOrgWaterMark: false,
  dingTalkAgentId: "325262018",
  syncToUserResource: true,
  resourceMark: true,
  enbaleCustomLayout: false,
  isLoadAllMenu: false,
  singleTab: false,
  tabNumber: 10,
  singleMenu: false,
  openDefaultMenu: true,
  isSwitchSkin: false,
  defaultPortal: "/kms/KmsConsole",
  fullScreen: "/drm/CommonResourceQuery,/drm/ResourceCollections,/drm/ResouceApplyQuery,/oa/InitiationProcess,/oa/ToDoProcess,/oa/CompletionProcess,/oa/PublishedProcess,/oa/ProcessStatistics",
  hideSingleTab: "/ckf/console,/trm/console,/act/console,/vol/console,/exp/console,/vip/console,/ams/console,/cms/console,/drm/console,/dem/console",
  //#endregion 逻辑交互配置区
  enableSsoLogin: false,
  ssoTokenName: "Zxy",
  enableModuleDeploy: false,
  moduleSites: '{"bdp":"http://localhost:4510/","drm":"http://localhost:4520/","oa":"http://localhost:4530/"}',
  defaultLanguage: "",
  projectName: "管理端登录",
  customerName: "大数据治理平台",
  projectLogo: "/assets/Theme/default/img/logo.png",
  projectLogoWidth: "200",
  loginStyle: 1,
  loginBackGround: "/assets/Theme/default/img/login-bg.jpg",
  favoriteIco: "/favicon.ico",
  coptyRight: "建议浏览器：chrome/360极速浏览器" //版权相关声明
  //#endregion
}
